import type {
  LeadTimeStrategyBuilder,
  LeadTimeStrategyResultBuilder,
} from '@calculations/lead-time/builders';
import type { VisualRunRateType } from '@snap-types/models/visual/operation/enums';
import type { Decimal } from '@snap-types/types/decimal';

export const QuantityAware = 'QuantityAware' as const;

export type QuantityAware = typeof QuantityAware;

export type QuantityAwareOperation = {
  sequenceNo: number;
  /** The shop resource the operation runs on, as Visual names it. */
  resourceId: string;
  runType: VisualRunRateType;
  run: Decimal | null;
  setupHours: Decimal | null;
  transitDays: Decimal | null;
  /** The ratio the site's quoting team adjusts this operation's run hours by.
   * `1` leaves them as the routing has them. */
  runHoursMultiplier: Decimal;
};

export type QuantityAwareInputs = {
  /** Weeks, as the planner typed them into `user_1` on the shop resource. */
  resourceLeadTimeWeeks: Decimal | null;
  /** Days, as Visual holds the planning lead time. Converted at the site's
   * `planningDaysPerWeek`, which is not always the working week. */
  materialLeadTimeDays: number | null;

  operations: QuantityAwareOperation[];
};

export type QuantityAwareConfig = {
  shiftHours: number;
  bufferDays: number;
  /** Move days per operation. Sites that do not move between every operation
   * set this below 1. */
  moveDayRatio: Decimal;
  /** The site's working week, for shop floor time. */
  productionDaysPerWeek: number;
  /** The week the site records outside service transit days on. */
  transitDaysPerWeek: number;
  /** The week the site records Visual planning lead times on. */
  planningDaysPerWeek: number;
};

export type QuantityAwareLeadTimeStrategy = LeadTimeStrategyBuilder<
  QuantityAware,
  QuantityAwareConfig
>;

export type QuantityAwareLeadTimeStrategyResult =
  LeadTimeStrategyResultBuilder<QuantityAware>;
